import { Helmet } from "react-helmet";
import NewHead from "../../landing/NewHead";
import "./ai-agent.css";
import ServiceFooter from "../../ServiceFooter";
import { useState } from "react";

import { Navigation, A11y, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { useEffect } from "react";
import Marquee from "react-marquee-slider";

const AIAgent = () => {
  const [isPrevChooseDisabled, setIsPrevChooseDisabled] = useState(true);
  const [isNextChooseDisabled, setIsNextChooseDisabled] = useState(false);

  const [isPrevkeyDisabled, setIsPrevkeyDisabled] = useState(true);
  const [isNextkeyDisabled, setIsNextkeyDisabled] = useState(false);

  const [velocity, setVelocity] = useState(60); // Default for larger screens

  const handleChooseChange = (chooseSwiper) => {
    setIsPrevChooseDisabled(chooseSwiper.isBeginning);
    setIsNextChooseDisabled(chooseSwiper.isEnd);
  };

  const handlekeyChange = (keySwiper) => {
    setIsPrevkeyDisabled(keySwiper.isBeginning);
    setIsNextkeyDisabled(keySwiper.isEnd);
  };

  // const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    const updateVelocity = () => {
      if (window.innerWidth <= 480) {
        setVelocity(20); // Very slow for small mobile
      } else if (window.innerWidth <= 768) {
        setVelocity(30); // Slower for mobile
      } else if (window.innerWidth <= 1600) {
        setVelocity(40); // Moderate speed for tablets
      } else {
        setVelocity(60); // Default speed for larger screens
      }
    };

    updateVelocity();
    window.addEventListener("resize", updateVelocity);
    return () => window.removeEventListener("resize", updateVelocity);
  }, []);

  return (
    <>
      <NewHead />

      <Helmet>
        <title>AI Agent Development Company</title>

        <meta name="title" content="AI Agent Development Company" />
        <meta
          name="description"
          content="Develop your AI agent with a renowned Ai development company in the industry. Get free consultation from our AI Experts."
        />

        <meta property="og:title" content="AI Agent Development Company" />
        <meta property="og:site_name" content="Beleaf Technologies" />

        <link
          rel="canonical"
          href="https://www.beleaftechnologies.com/ai-agent-development-company"
        />
      </Helmet>

      <main className="landingMain aiagent-main">
        {/* hero */}
        <div className="primary__landing__container agent-mb">
          <div className="ai-agent-hero">
            <h1 className="ai-agent-hero-title">
              <span className="ai-hero-spark-img">
                <img
                  src={require("../../../image/ai-agent/hero-sparkle.webp")}
                  alt="AI Agent Development Company"
                  loading="lazy"
                />
              </span>
              AI Agent Development Company
            </h1>
            <p className="ai-agent-hero-content">
              Our AI agent development company specialize in creating
              intelligent agents that seamlessly integrate with your business
              processes to boost efficiency and deliver unmatched value. Whether
              you need AI-powered chatbots, virtual assistants, or complex
              decision-making systems, we have the expertise to bring your
              vision to life.
            </p>
            <div className="text-center">
              <button
                data-toggle="modal"
                data-target="#myModal"
                className="ai-agent-btn"
              >
                <span className="ai-agent-btn-span">
                  Get Free Consultation{" "}
                  <i className="fa-solid fa-arrow-right"></i>
                </span>
              </button>
            </div>
          </div>
        </div>
        {/* about */}
        <div className="primary__landing-content-container agent-mb">
          <div className="agent-about ">
            <h5 className="agent-subtitle">What Is An AI Agent?</h5>
            <p className="agent-subcontent agent-about-mw">
              An AI agent is a software system created to observe its
              surroundings, process information, and make decisions to achieve
              specific goals. These agents can operate independently or with
              limited supervision, performing various functions such as:
              Interacting with users using natural language processing (NLP).
              Offering tailored recommendations based on user behavior and
              preferences. Automating repetitive tasks to improve efficiency and
              save resources. Assisting in complex decision-making by delivering
              data-driven insights.
            </p>
            <div className="text-center">
              <button
                data-toggle="modal"
                data-target="#myModal"
                className="ai-agent-btn"
              >
                <span className="ai-agent-btn-span">
                  Get Free Demo <i className="fa-solid fa-arrow-right"></i>
                </span>
              </button>
            </div>
          </div>
        </div>
        {/* why choose */}
        <div className="primary__landing__container agent-mb">
          <h5 className="agent-subtitle ">
            Why Choose Our{" "}
            <span className="why-choose-title-span">
              AI Agent Development Company?{" "}
            </span>
          </h5>
          <p className="agent-subcontent agent-why-choose-content">
            As a leading AI agent development company, we pride ourselves on
            delivering innovative, customized, and high-performing AI solutions.
            Here’s the reason why businesses choose us
          </p>

          <div className="row g-4 agent-why-choose-row">
            <div className="col-lg-6 col-md-6">
              <div className="agent-why-card">
                <img
                  src="https://res.cloudinary.com/dvym3pvnu/image/upload/v1777470141/why-img-oneNew_knnd8y.webp"
                  alt="AI Agent Development Company"
                  loading="lazy"
                  className="why-img"
                />
                <img
                  src="https://res.cloudinary.com/dvym3pvnu/image/upload/v1777470140/why-img-one-hoverNew_mya8cj.webp"
                  alt="AI Agent Development Company"
                  loading="lazy"
                  className="why-img-none"                              
                />
                <div className="agent-why-content-wrap">
                  <h5>Expert Team of AI Professionals</h5>
                  <p>
                    Our team comprises AI researchers, data scientists, software
                    engineers, and UX/UI designers who work together to develop
                    cutting-edge AI agents tailored to your needs.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-6">
              <div className="agent-why-card col-two">
                <div className="why-custom-img-wrap">
                  <img
                    src="https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746876083/why-custom-img_bsmylg.webp"
                    alt="AI Agent Development Company"
                    loading="lazy"
                    className="why-custom-img-one"
                  />
                  <img
                    src="https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746876083/why-custom-img_bsmylg.webp"
                    alt="AI Agent Development Company"
                    loading="lazy"
                    className="why-custom-img-two"
                  />
                  <span className="why-custom-ai">
                    <img
                      src="https://res.cloudinary.com/dvym3pvnu/image/upload/v1777438910/why-custom-aiNew_vjcdby.webp"
                      alt="AI Agent Development Company"
                      loading="lazy"
                    />
                  </span>
                </div>

                <div className="agent-why-content-wrap contents">
                  <h5>Custom Solutions for Every Business</h5>
                  <p>
                    We understand that each business is unique. Our AI solutions
                    are customized to align with your industry, goals, and
                    specific use cases, ensuring maximum ROI.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="agent-why-card">
                <div className="agent-why-content-wrap">
                  <div className="why-graph-wrap">
                    <img
                      src="https://res.cloudinary.com/dvym3pvnu/image/upload/v1777463640/why_graphNew_asgazt.webp"
                      alt="AI Agent Development Company"
                      loading="lazy"
                    />
                    <span>
                      <img
                        src="https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746876084/why-graph-one_w6apde.webp"
                        alt="AI Agent Development Company"
                        loading="lazy"
                        className="why-graph-one"
                      />
                    </span>
                    <span>
                      <img
                        src="https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746876084/why-graph-two_igtszq.webp"
                        alt="AI Agent Development Company"
                        loading="lazy"
                        className="why-graph-two"
                      />
                    </span>
                  </div>
                  <h5>Proven Track Record</h5>
                  <p>
                    With successful projects spanning multiple industries, we
                    have built a reputation for reliability and excellence in AI
                    agent development.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="agent-why-card">
                <div>
                  <div className="agent-seam-inner">
                    <img
                      src="https://res.cloudinary.com/dvym3pvnu/image/upload/v1777463795/why-seamNew_aytbdp.webp"
                      alt="AI Agent Development Company"
                      loading="lazy"
                      className="agent-seam-one"
                    />
                  </div>
                  <span className="agent-seam-two">
                    <img
                      src="https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746876089/why-seam-two_x0rynp.webp"
                      alt="AI Agent Development Company"
                      loading="lazy"
                    />
                  </span>
                </div>

                <div className="agent-why-content-wrap">
                  <h5>Seamless Integration</h5>
                  <p>
                    We ensure that our AI agents integrate seamlessly with your
                    existing systems, ensuring minimal disruption and maximum
                    efficiency.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="agent-why-card">
                <div>
                  <div className="agent-cont-inner">
                    <img
                      src="https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746876085/why-cont_kok8hm.webp"
                      alt="AI Agent Development Company"
                      loading="lazy"
                    />
                  </div>
                  <span className="agent-seam-two">
                    <img
                      src="https://res.cloudinary.com/dmjw7pe6k/image/upload/v1746876088/why-msg_wsxp8t.webp"
                      alt="AI Agent Development Company"
                      loading="lazy"
                    />
                  </span>
                </div>
                <div className="agent-why-content-wrap">
                  <h5>Continuous Support & Upgrades</h5>
                  <p>
                    Technology evolves rapidly, and so do we. Our AI agent
                    development company provides ongoing support and upgrades to
                    keep your AI agents performing at their best.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* our services */}
        <div className="primary__landing__container agent-mb">
          <div className="agent-our-services ">
            <h5 className="agent-subtitle agent-our-service-title">
              Our AI Agent Development Services
            </h5>
            <p className="agent-subcontent agent-our-ai-content">
              As a premier AI agent development company, we offer comprehensive
              services to cater to diverse business needs
            </p>

            <div className="agent-our-slider">
              <Swiper
                className="agent-our-swiper h-100"
                style={{ width: "100%", height: "100%" }}
                spaceBetween={30}
                slidesPerView={3}
                modules={[Navigation, A11y, Pagination]}
                pagination={{
                  clickable: true,
                }}
                scrollbar={{ draggable: true }}
                navigation={{
                  prevEl: ".agent-our-prev-arrow",
                  nextEl: ".agent-our-next-arrow",
                }}
                breakpoints={{
                  320: {
                    slidesPerView: 1,
                    spaceBetween: 10,
                  },
                  480: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                  },
                  768: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                  },
                  1025: {
                    slidesPerView: 3,
                    spaceBetween: 40,
                  },
                }}
                onSlideChange={handleChooseChange}
                onReachBeginning={() => setIsPrevChooseDisabled(true)}
                onReachEnd={() => setIsNextChooseDisabled(true)}
                onFromEdge={() => {
                  setIsPrevChooseDisabled(false);
                  setIsNextChooseDisabled(false);
                }}
              >
                <SwiperSlide style={{ height: "100%" }}>
                  <div className="mt-5 h-100">
                    <div className="agent-our-card h-100">
                      <img
                        src="https://res.cloudinary.com/dvym3pvnu/image/upload/v1777296630/our-img-oneNew_uttix7.webp"
                        alt="AI Agent Development Company"
                        loading="lazy"
                        className="agent-our-img"
                      />
                      <img
                        src="https://res.cloudinary.com/dvym3pvnu/image/upload/v1777296630/our-img-one-activeNew_co8hp9.webp"
                        alt="AI Agent Development Company"
                        loading="lazy"
                        className="agent-our-img-hover"
                      />
                      <div className="agent-our-content-wrap">
                        <h5>Custom AI Agent Development</h5>
                        <p>
                          We design and develop AI agents tailored to your
                          specific requirements, whether for customer service,
                          data analysis, or operational efficiency.
                        </p>
                      </div>
                      <div className="agent-our-grad"></div>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide style={{ height: "100%" }}>
                  <div className="mt-5 h-100">
                    <div className="agent-our-card h-100">
                      <img
                        src="https://res.cloudinary.com/dvym3pvnu/image/upload/v1777296669/our-img-twoNew_ndsglu.webp"
                        alt="AI Agent Development Company"
                        loading="lazy"
                        className="agent-our-img"
                      />
                      <img
                        src="https://res.cloudinary.com/dvym3pvnu/image/upload/v1777296670/our-img-two-activeNew_pqum2q.webp"
                        alt="AI Agent Development Company"
                        loading="lazy"
                        className="agent-our-img-hover"
                      />
                      <div className="agent-our-content-wrap">
                        <h5>AI-Powered Chatbot Development</h5>
                        <p>
                          Enhance customer interactions with intelligent
                          chatbots capable of understanding and responding to
                          user queries in real time.
                        </p>
                      </div>
                      <div className="agent-our-grad"></div>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide style={{ height: "100%" }}>
                  <div className="mt-5 h-100">
                    <div className="agent-our-card h-100">
                      <img
                        src="https://res.cloudinary.com/dvym3pvnu/image/upload/v1777297126/our-img-threeNew_engl3b.webp"
                        alt="AI Agent Development Company"
                        loading="lazy"
                        className="agent-our-img"
                      />
                      <img
                        src="https://res.cloudinary.com/dvym3pvnu/image/upload/v1777297127/our-img-three-activeNew_kxyd8z.webp"
                        alt="AI Agent Development Company"
                        loading="lazy"
                        className="agent-our-img-hover"
                      />
                      <div className="agent-our-content-wrap">
                        <h5>Virtual Assistant Development</h5>
                        <p>
                          Our virtual assistants streamline workflows, handle
                          administrative tasks, and provide intelligent insights
                          to support decision-making.
                        </p>
                      </div>
                      <div className="agent-our-grad"></div>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide style={{ height: "100%" }}>
                  <div className="mt-5 h-100">
                    <div className="agent-our-card h-100">
                      <img
                        src="https://res.cloudinary.com/dvym3pvnu/image/upload/v1777297180/our-img-fourNew_xxvph0.webp"
                        alt="AI Agent Development Company"
                        loading="lazy"
                        className="agent-our-img"
                      />
                      <img
                        src="https://res.cloudinary.com/dvym3pvnu/image/upload/v1777297182/our-img-four-activeNew_qsopn2.webp"
                        alt="AI Agent Development Company"
                        loading="lazy"
                        className="agent-our-img-hover"
                      />
                      <div className="agent-our-content-wrap">
                        <h5>Machine Learning Integration</h5>
                        <p>
                          We leverage machine learning algorithms to create
                          adaptive AI agents that continuously improve their
                          performance.
                        </p>
                      </div>
                      <div className="agent-our-grad"></div>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide style={{ height: "100%" }}>
                  <div className="mt-5 h-100">
                    <div className="agent-our-card h-100">
                      <img
                        src="https://res.cloudinary.com/dvym3pvnu/image/upload/v1777297295/our-img-fiveNew_dsmuy7.webp"
                        alt="AI Agent Development Company"
                        loading="lazy"
                        className="agent-our-img"
                      />
                      <img
                        src="https://res.cloudinary.com/dvym3pvnu/image/upload/v1777297296/our-img-five-activeNew_rjmb6r.webp"
                        alt="AI Agent Development Company"
                        loading="lazy"
                        className="agent-our-img-hover"
                      />
                      <div className="agent-our-content-wrap">
                        <h5>Voice-Enabled AI Agents</h5>
                        <p>
                          Develop AI agents equipped with voice recognition and
                          synthesis capabilities for hands-free operations.
                        </p>
                      </div>
                      <div className="agent-our-grad"></div>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide style={{ height: "100%" }}>
                  <div className="mt-5 h-100">
                    <div className="agent-our-card h-100">
                      <img
                        src="https://res.cloudinary.com/dvym3pvnu/image/upload/v1777297339/our-img-sixNew_wtwgan.webp"
                        alt="AI Agent Development Company"
                        loading="lazy"
                        className="agent-our-img"
                      />
                      <img
                        src="https://res.cloudinary.com/dvym3pvnu/image/upload/v1777297341/our-img-six-activeNew_szcm8x.webp"
                        alt="AI Agent Development Company"
                        loading="lazy"
                        className="agent-our-img-hover"
                      />
                      <div className="agent-our-content-wrap">
                        {" "}
                        <h5>Predictive Analytics Agents</h5>
                        <p>
                          Transform your data into actionable insights with AI
                          agents that analyze trends and predict future
                          outcomes.
                        </p>
                      </div>
                      <div className="agent-our-grad"></div>
                    </div>
                  </div>
                </SwiperSlide>
              </Swiper>

              <div className="agent-our-btn-wrapper">
                <button
                  className={`agent-our-prev-arrow ${
                    isPrevChooseDisabled ? "disabled" : ""
                  }`}
                  style={{
                    color: isPrevChooseDisabled ? "#70befa66" : "#70befa",
                    cursor: isPrevChooseDisabled ? "not-allowed" : "pointer",
                    background: isPrevChooseDisabled
                      ? "#ffffff14"
                      : "#ffffff23",
                  }}
                >
                  <i className="fa-solid fa-chevron-left"></i>
                </button>
                <button
                  className={`agent-our-next-arrow ${
                    isNextChooseDisabled ? "disabled" : ""
                  }`}
                  style={{
                    color: isNextChooseDisabled ? "#70befa66" : "#70befa",
                    cursor: isNextChooseDisabled ? "not-allowed" : "pointer",
                    background: isNextChooseDisabled
                      ? "#ffffff14"
                      : "#ffffff23",
                  }}
                >
                  <i className="fa-solid fa-chevron-right"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* our development process */}
        <div className="primary__landing__container agent-mb">
          <div className="agent-development">
            <h5 className="agent-subtitle agent-key-title">
              Our Development Process
            </h5>
            <p className="agent-subcontent agent-dev-content">
              At our AI agent development company, we follow a structured
              approach to ensure the success of your AI project
            </p>

            <div className="agent-dev-row-wrap">
              <div className="row agent-dev-row">
                <div className="col-lg-4  text-center">
                  <div className="agent-dev-card ">
                    <div className="card-one">
                      <img
                        src={require("../../../image/ai-agent/dev-img-one.webp")}
                        alt="AI Agent Development Company"
                        loading="lazy"
                      />
                    </div>
                    <h6>Requirement Analysis</h6>
                    <p>
                      Collaborating with you to understand your objectives,
                      challenges, and expectations.
                    </p>
                  </div>
                </div>
                <div className="col-lg-4  text-center">
                  <div className="agent-dev-card">
                    <div className="card-two">
                      <img
                        src={require("../../../image/ai-agent/dev-img-two.webp")}
                        alt="AI Agent Development Company"
                        loading="lazy"
                      />
                    </div>

                    <h6>Design & Prototyping</h6>
                    <p>
                      Creating a detailed design and prototype of the AI agent
                      to visualize its functionality.
                    </p>
                  </div>
                </div>
                <div className="col-lg-4  text-center">
                  <div className="agent-dev-card ">
                    <div className="">
                      <img
                        src={require("../../../image/ai-agent/dev-img-three.webp")}
                        alt="AI Agent Development Company"
                        loading="lazy"
                      />
                    </div>

                    <h6>Development</h6>
                    <p>
                      Developing the AI agent with cutting-edge technologies and
                      advanced algorithms.
                    </p>
                  </div>
                </div>
              </div>
              <div className="row agent-dev-row-two">
                <div className="col-lg-4  text-center">
                  <div className="agent-dev-card">
                    <div className="card-five">
                      <img
                        src={require("../../../image/ai-agent/dev-img-six.webp")}
                        alt="AI Agent Development Company"
                        loading="lazy"
                      />
                    </div>
                    <h6>Support & Maintenance</h6>
                    <p>
                      Offering continuous support, updates, and enhancements to
                      keep the AI agent up-to-date.
                    </p>
                  </div>
                </div>
                <div className="col-lg-4  text-center">
                  <div className="agent-dev-card">
                    <div className="card-four">
                      <img
                        src={require("../../../image/ai-agent/dev-img-five.webp")}
                        alt="AI Agent Development Company"
                        loading="lazy"
                      />
                    </div>
                    <h6>Deployment</h6>
                    <p>
                      Incorporating the AI agent into your systems and offering
                      training for your team.
                    </p>
                  </div>
                </div>
                <div className="col-lg-4  text-center">
                  <div className="agent-dev-card ">
                    <div className="card-three">
                      <img
                        src={require("../../../image/ai-agent/dev-img-four.webp")}
                        alt="AI Agent Development Company"
                        loading="lazy"
                      />
                    </div>
                    <h6>Testing & Optimization</h6>
                    <p>
                      Rigorously testing the AI agent to ensure accuracy,
                      reliability, and performance.
                    </p>
                  </div>
                </div>
              </div>

              <img
                src={require("../../../image/ai-agent/dev-leftNew.webp")}
                alt="AI Agent Development Company"
                loading="lazy"
                className="dev-left"
              />
              <img
                src={require("../../../image/ai-agent/dev-rightNew.webp")}
                alt="AI Agent Development Company"
                loading="lazy"
                className="dev-right"
              />
            </div>
          </div>
        </div>
        {/* industries */}
        <div className="agent-mb">
          <div className="primary__landing__container ">
            <div className="agent-industries">
              <h5 className="agent-subtitle agent-key-title">
                Industries We Serve
              </h5>
              <p className="agent-subcontent agent-key-content">
                Our AI agent development company caters to a wide range of
                industries, including
              </p>
            </div>
          </div>

          <div className="agent-marquee-wrap-outer">
            <div
              // onMouseEnter={() => setIsHovered(true)}
              // onMouseLeave={() => setIsHovered(false)}
              className="agent-marquee-wrap"
            >
              <Marquee
                className="marquee-outer"
                velocity={velocity}
                direction="rtl"
                resetAfterTries={200}
                // velocity={isHovered ? 0 : velocity}
              >
                <div className="agent-industry-card">
                  <img
                    src={require("../../../image/ai-agent/finance.webp")}
                    alt="AI Agent Development Company"
                    loading="lazy"
                  />
                  <h6>Finance</h6>
                  <p>
                    Fraud detection, risk assessment, and automated financial
                    advisory services.
                  </p>
                </div>
                <div className="agent-industry-card">
                  <img
                    src={require("../../../image/ai-agent/edu.webp")}
                    alt="AI Agent Development Company"
                    loading="lazy"
                  />
                  <h6>Education</h6>
                  <p>
                    AI-powered tutors, virtual classrooms, and personalized
                    learning experiences.
                  </p>
                </div>
                <div className="agent-industry-card">
                  <img
                    src={require("../../../image/ai-agent/manufacturing.webp")}
                    alt="AI Agent Development Company"
                    loading="lazy"
                  />
                  <h6>Manufacturing</h6>
                  <p>
                    Streamlining production processes, enabling predictive
                    maintenance, and optimizing supply chain operations.
                  </p>
                </div>
                <div className="agent-industry-card">
                  <img
                    src={require("../../../image/ai-agent/real-estate.webp")}
                    alt="AI Agent Development Company"
                    loading="lazy"
                  />
                  <h6>Real Estate</h6>
                  <p>
                    AI agents for property recommendations, virtual tours, and
                    market analysis.
                  </p>
                </div>
                <div className="agent-industry-card">
                  <img
                    src={require("../../../image/ai-agent/travel.webp")}
                    alt="AI Agent Development Company"
                    loading="lazy"
                  />
                  <h6>Travel and Hospitality</h6>
                  <p>
                    AI-driven booking systems, virtual travel assistants, and
                    customer support agents.
                  </p>
                </div>
                <div className="agent-industry-card">
                  <img
                    src={require("../../../image/ai-agent/healthcare.webp")}
                    alt="AI Agent Development Company"
                    loading="lazy"
                  />
                  <h6>Healthcare</h6>
                  <p>
                    AI agents for patient triage, medical diagnostics, and
                    personalized healthcare recommendations.
                  </p>
                </div>
              </Marquee>
              <div className="agent-marquee-two">
                <Marquee
                  velocity={velocity}
                  direction="ltr"
                  resetAfterTries={200}
                >
                  <div className="agent-industry-card">
                    <img
                      src={require("../../../image/ai-agent/finance.webp")}
                      alt="AI Agent Development Company"
                      loading="lazy"
                    />
                    <h6>Finance</h6>
                    <p>
                      Fraud detection, risk assessment, and automated financial
                      advisory services.
                    </p>
                  </div>
                  <div className="agent-industry-card">
                    <img
                      src={require("../../../image/ai-agent/edu.webp")}
                      alt="AI Agent Development Company"
                      loading="lazy"
                    />
                    <h6>Education</h6>
                    <p>
                      AI-powered tutors, virtual classrooms, and personalized
                      learning experiences.
                    </p>
                  </div>
                  <div className="agent-industry-card">
                    <img
                      src={require("../../../image/ai-agent/manufacturing.webp")}
                      alt="AI Agent Development Company"
                      loading="lazy"
                    />
                    <h6>Manufacturing</h6>
                    <p>
                      Streamlining production processes, enabling predictive
                      maintenance, and optimizing supply chain operations.
                    </p>
                  </div>
                  <div className="agent-industry-card">
                    <img
                      src={require("../../../image/ai-agent/real-estate.webp")}
                      alt="AI Agent Development Company"
                      loading="lazy"
                    />
                    <h6>Real Estate</h6>
                    <p>
                      AI agents for property recommendations, virtual tours, and
                      market analysis.
                    </p>
                  </div>
                  <div className="agent-industry-card">
                    <img
                      src={require("../../../image/ai-agent/travel.webp")}
                      alt="AI Agent Development Company"
                      loading="lazy"
                    />
                    <h6>Travel and Hospitality</h6>
                    <p>
                      AI-driven booking systems, virtual travel assistants, and
                      customer support agents.
                    </p>
                  </div>
                  <div className="agent-industry-card">
                    <img
                      src={require("../../../image/ai-agent/healthcare.webp")}
                      alt="AI Agent Development Company"
                      loading="lazy"
                    />
                    <h6>Healthcare</h6>
                    <p>
                      AI agents for patient triage, medical diagnostics, and
                      personalized healthcare recommendations.
                    </p>
                  </div>
                </Marquee>
              </div>

              {/* <div className="marquee-fade"></div> */}
            </div>
          </div>
        </div>
        {/* key features */}
        <div className="primary__landing__container agent-mb">
          <div className="agent-key-features">
            <h5 className="agent-subtitle agent-key-title ">
              Key Features of AI Agents Developed by Our Company
            </h5>
            <p className="agent-subcontent agent-key-content ">
              Our AI agents are designed with the following features to ensure
              exceptional performance
            </p>

            <div className="agent-key-slider">
              <Swiper
                className="agent-key-swiper h-100"
                style={{ width: "100%", height: "100%" }}
                spaceBetween={30}
                slidesPerView={3}
                modules={[Navigation, A11y, Pagination]}
                pagination={{
                  clickable: true,
                }}
                scrollbar={{ draggable: true }}
                navigation={{
                  prevEl: ".agent-key-prev-arrow",
                  nextEl: ".agent-key-next-arrow",
                }}
                breakpoints={{
                  320: {
                    slidesPerView: 1,
                    spaceBetween: 10,
                  },
                  480: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                  },
                  768: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                  },
                  1025: {
                    slidesPerView: 4,
                    spaceBetween: 40,
                  },
                }}
                onSlideChange={handlekeyChange}
                onReachBeginning={() => setIsPrevkeyDisabled(true)}
                onReachEnd={() => setIsNextkeyDisabled(true)}
                onFromEdge={() => {
                  setIsPrevkeyDisabled(false);
                  setIsNextkeyDisabled(false);
                }}
              >
                <SwiperSlide>
                  <div className="mt-5 h-100">
                    <div className="agent-key-card ">
                      <div className="agent-key-img-card">
                        <img
                          src={require("../../../image/ai-agent/key-img-oneNew.webp")}
                          alt="AI Agent Development Company"
                          loading="lazy"
                        />
                      </div>
                      <h6>Natural Language Processing (NLP)</h6>
                      <p>
                        Allows the agent to comprehend and interact with human
                        language efficiently.
                      </p>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="mt-5 h-100">
                    <div className="agent-key-card ">
                      <div className="agent-key-img-card">
                        <img
                          src={require("../../../image/ai-agent/key-img-twoNew.webp")}
                          alt="AI Agent Development Company"
                          loading="lazy"
                        />
                      </div>
                      <h6>Scalability</h6>
                      <p>
                        Built to handle increasing workloads as your business
                        grows.
                      </p>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="mt-5 h-100">
                    <div className="agent-key-card ">
                      <div className="agent-key-img-card">
                        <img
                          src={require("../../../image/ai-agent/key-img-threeNew.webp")}
                          alt="AI Agent Development Company"
                          loading="lazy"
                        />
                      </div>
                      <h6>Data Security</h6>
                      <p>
                        Utilizes advanced encryption and security protocols to
                        safeguard sensitive data.
                      </p>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="mt-5 h-100">
                    <div className="agent-key-card ">
                      <div className="agent-key-img-card">
                        <img
                          src={require("../../../image/ai-agent/key-img-fourNew.webp")}
                          alt="AI Agent Development Company"
                          loading="lazy"
                        />
                      </div>
                      <h6>Customizability</h6>
                      <p>
                        Fully developed to meet your specific business
                        necessities.
                      </p>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="mt-5 h-100">
                    <div className="agent-key-card ">
                      <div className="agent-key-img-card">
                        <img
                          src={require("../../../image/ai-agent/key-img-fiveNew.webp")}
                          alt="AI Agent Development Company"
                          loading="lazy"
                        />
                      </div>
                      <h6>Adaptability</h6>
                      <p>
                        Continuous learning capabilities to improve performance
                        over time.
                      </p>
                    </div>
                  </div>
                </SwiperSlide>
              </Swiper>

              <div className="agent-key-btn-wrapper">
                <button
                  className={`agent-key-prev-arrow ${
                    isPrevkeyDisabled ? "disabled" : ""
                  }`}
                  style={{
                    color: isPrevkeyDisabled ? "#70befa66" : "#70befa",
                    cursor: isPrevkeyDisabled ? "not-allowed" : "pointer",
                    background: isPrevkeyDisabled ? "#ffffff14" : "#ffffff23",
                  }}
                >
                  <i className="fa-solid fa-chevron-left"></i>
                </button>
                <button
                  className={`agent-key-next-arrow ${
                    isNextkeyDisabled ? "disabled" : ""
                  }`}
                  style={{
                    color: isNextkeyDisabled ? "#70befa66" : "#70befa",
                    cursor: isNextkeyDisabled ? "not-allowed" : "pointer",
                    background: isNextkeyDisabled ? "#ffffff14" : "#ffffff23",
                  }}
                >
                  <i className="fa-solid fa-chevron-right"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* benefits */}
        <div className="primary__landing__container agent-mb">
          <div className="agent-benefits">
            <h5 className="agent-subtitle agent-ben-title">
              {" "}
              Benefits of Partnering with{" "}
              <span className="why-choose-title-span">
                Our AI Agent Development Company
              </span>
            </h5>

            <div className="row m-0 g-4 agent-ben-row">
              <div className="col-md-4 ">
                <div className="agent-ben-cards">
                  <span>01</span>
                  <h4>Enhanced Efficiency</h4>
                  <p>
                    Streamline repetitive tasks, enabling your team to
                    concentrate on strategic priorities.
                  </p>
                </div>
              </div>
              <div className="col-md-4  agent-ben-y">
                <div className="agent-ben-cards">
                  <span>02</span>
                  <h4>Improved Customer Experience</h4>
                  <p>
                    Deliver personalized and timely responses to customer
                    queries with AI-powered solutions.
                  </p>
                </div>
              </div>
              <div className="col-md-4  ">
                <div className="agent-ben-cards">
                  <span>03</span>
                  <h4>Cost Savings</h4>
                  <p>
                    Lower operational expenses by optimizing workflows and
                    reducing mistakes.
                  </p>
                </div>
              </div>
              <div className="col-md-4 ">
                <div className="agent-ben-cards">
                  <span>04</span>
                  <h4>Data-Driven Insights</h4>
                  <p>
                    Leverage real-time analytics to make informed decisions and
                    stay ahead of competitors.
                  </p>
                </div>
              </div>
              <div className="col-md-4 m-0"></div>
              <div className="col-md-4 ">
                <div className="agent-ben-cards">
                  <span>05</span>
                  <h4>Scalable Solutions</h4>
                  <p>
                    Our AI agents grow with your business, ensuring long-term
                    value and adaptability.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* The future */}
        <div className="primary__landing-content-container agent-mb">
          <div className="agent-about">
            <h5 className="agent-subtitle">
              The Future of AI Agent Development
            </h5>
            <p className="agent-subcontent agent-about-mw">
              AI agents are at the forefront of technological innovation,
              driving the next wave of digital transformation. As a
              forward-thinking AI agent development company, we stay ahead of
              industry trends, incorporating advancements like ethical AI,
              explainable AI, and edge AI into our solutions. From enabling
              smarter cities to enhancing human-computer interactions, the
              possibilities are limitless.
            </p>
            <div className="text-center">
              <button
                data-toggle="modal"
                data-target="#myModal"
                className="ai-agent-btn"
              >
                <span className="ai-agent-btn-span">
                  Get Free Demo <i className="fa-solid fa-arrow-right"></i>
                </span>
              </button>
            </div>
          </div>
        </div>
        {/* get started */}
        <div className="agent-get-started">
          <div className="primary__landing-content-container">
            <h5 className="agent-get-title">
              Get Started with{" "}
              <span className="why-choose-title-span">
                the Best AI Agent Development Company
              </span>
            </h5>
            <p className="agent-get-content">
              Are you ready to elevate your business with cutting-edge AI
              solutions? Partner with our AI agent development company to unlock
              the full potential of intelligent automation. Contact us today to
              talk about your project and learn how we can help you reach your
              goals. Let’s shape the future together.
            </p>
            <div className="text-center">
              <button
                data-toggle="modal"
                data-target="#myModal"
                className="agent-get-btn"
              >
                Get Free Consultation{" "}
                <span className="mx-2 right-arr">
                  <i className="fa-solid fa-arrow-right" aria-hidden="true"></i>
                </span>
              </button>
            </div>
          </div>
        </div>
      </main>

      <article className="primary__landing-content-container">
        <div className="landing-faq-wrapper">
          <div className="row">
            <div className="col-lg-6">
              <h6 className="landing-faq-left-title">
                Frequently Asked <span className="faq-span">Questions.</span>{" "}
                {""}
              </h6>
            </div>
            <div className="col-lg-6">
              <div>
                <div className="container">
                  <div className="accordion" id="faq">
                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead1">
                        <a
                          href="#"
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq1"
                          aria-expanded="true"
                          aria-controls="faq1"
                        >
                          What is an AI agent?
                        </a>
                      </div>

                      <div
                        id="faq1"
                        className="collapse"
                        aria-labelledby="faqhead1"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          An AI agent is a software designed to perceive its
                          environment, process data, and take actions to achieve
                          specific goals.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead2">
                        <a
                          href="#"
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq2"
                          aria-expanded="true"
                          aria-controls="faq2"
                        >
                          How long does it take to develop an AI agent?
                        </a>
                      </div>

                      <div
                        id="faq2"
                        className="collapse"
                        aria-labelledby="faqhead2"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          The development timeline varies depending on the
                          complexity of the project but typically ranges from a
                          few weeks to a few months.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead3">
                        <a
                          href="#"
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq3"
                          aria-expanded="true"
                          aria-controls="faq3"
                        >
                          What industries can benefit from AI agents?
                        </a>
                      </div>

                      <div
                        id="faq3"
                        className="collapse"
                        aria-labelledby="faqhead3"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          AI agents are versatile and can be applied across
                          industries such as healthcare, finance, retail,
                          manufacturing, and more.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead4">
                        <a
                          href="#"
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq4"
                          aria-expanded="true"
                          aria-controls="faq44"
                        >
                          Do you provide post-deployment support?
                        </a>
                      </div>

                      <div
                        id="faq4"
                        className="collapse"
                        aria-labelledby="faqhead4"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          Yes, our AI agent development company offers
                          comprehensive support and maintenance to ensure
                          optimal performance.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead5">
                        <a
                          href="#"
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq5"
                          aria-expanded="true"
                          aria-controls="faq5"
                        >
                          How much does it cost to develop an AI agent?
                        </a>
                      </div>

                      <div
                        id="faq5"
                        className="collapse"
                        aria-labelledby="faqhead5"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          The cost depends on factors like features, complexity,
                          and industry requirements. Contact us for a
                          personalized quote.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </article>

      <ServiceFooter />
    </>
  );
};

export default AIAgent;
